import { Routes } from '@angular/router';

export default [
    {
        //TODO: cleanup when all dependencies are handled
        path: 'mobileportal/:pathMatch',
        redirectTo: 'myaccount/:pathMatch',
        pathMatch: 'prefix',
    },
] satisfies Routes;
